<template>
    <div class="buyr">
        <h4>{{name}}注册</h4>
        <div style="padding:60px;">
            <el-form ref="regForm" :model="regModel" :rules="rules">
                <el-form-item prop="mobile">
                    <el-input v-model="regModel.mobile"></el-input>
                </el-form-item>
                <el-form-item prop="code">
                    <el-input v-model="regModel.code">
                        <el-button slot="append" icon="el-icon-s-promotion" type="danger" plain>获取验证码</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="width:100%" type="danger" @click="onSubmit">立即创建</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
module.exports = {
  data: function () {
    return {
      regModel: { mobile: '', code: '' },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  props: ['name'],
  methods: {
    onSubmit () {
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
